import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-recepit-credit',
  templateUrl: './recepit-credit.component.html',
  styleUrls: ['./recepit-credit.component.css']
})
export class ReceiptCreditComponent implements OnInit {
  title = "Receipt Credit"
  constructor() { }

  ngOnInit() {
  }

}



// WEBPACK FOOTER //
// ./src/app/general-transaction/recepit-credit/recepit-credit.component.ts